/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Landing_Studio_PassInputs */

const en_landing_studio_pass = /** @type {(inputs: Landing_Studio_PassInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pass ${i?.n}`)
};

const zh_landing_studio_pass = /** @type {(inputs: Landing_Studio_PassInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.n} 轮`)
};

/**
* | output |
* | --- |
* | "Pass {n}" |
*
* @param {Landing_Studio_PassInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_pass = /** @type {((inputs: Landing_Studio_PassInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_PassInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_pass(inputs)
	return zh_landing_studio_pass(inputs)
});
export { landing_studio_pass as "landing.studio.pass" }